<script>
import BtnModul from "@/components/btn-module.vue";

export default {
  components: {
    BtnModul,
  },
  data() {
    return {}

}}
</script>

<template>
  <div class="footer-container">
  <div class="app-bar px-3 bg-blue-50 w-100 d-flex align-items-center align-content-center ">
    <div class="container-fluid d-flex flex-row align-items-center">
      
        
        <div class="footer-menu mx-5">
 
          <btnModul style="display:none" link="a" title="Favori Uygulamalar" icon="fa-paper-plane" notifi="3"/>
        
        </div>
      
    </div>
  </div>
  <footer class="footer h-auto p-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} {{ this.$t('Footer.Sol') }}</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">{{ this.$t('Footer.Sag') }}</div>
        </div>
      </div>
    </div>
  </footer>
  </div>
  <!-- end footer -->
</template>

<style>
.footer .col-sm-6{
  font-size: 10px;
}
.bg-blue-50{
  background: #e7e7e7;
}
.app-bar{
  height: 53px;
  position: absolute;
  bottom: 47px;
  left:0px;
  border-top: 3px solid #2a3042;
}
.footer-menu{
  margin-top: -49px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  text-align: center;
  flex-grow: 1;
}



</style>